var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height flex"},[_c('Sidebar'),_c('div',{staticClass:"dashboard-container flex1 p-2 flex fd-c fgap2"},[(!_vm.hideHeader)?_c('Header'):_vm._e(),_c('transition',{attrs:{"name":"pages","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }